var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGetLinkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 666.7 666.7",
    style: {
      enableBackground: "new 0 0 666.7 666.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\n\t.st1{fill:#2159D1;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 342.4,
    cy: 323.8,
    r: 257.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M333.3,0C149.3,0,0,149.3,0,333.3s149.3,333.3,333.3,333.3s333.3-149.3,333.3-333.3S517.3,0,333.3,0z  M221.7,425.7c-3.7,10-13.3,16.3-23.3,16.3c-3,0-5.7-0.3-8.7-1.7c-27-10-49.7-29.7-64-55.3c-33.3-60-12.7-138.3,45.7-174.7l78-48.3 c28.7-17.7,62.3-23,94.3-14.7s59,29.3,75.3,58.7c33.3,60,12.7,138.3-45.7,174.7l-8.7,6.3c-11.3,8-27,5.3-35-5.7 c-8-11.3-5.3-27,5.7-35l10.3-7.3c37.3-23.3,50-71.7,29.7-108.7c-9.7-17.3-25.3-29.7-44-34.7s-38.3-2-55.3,8.7L197.3,253 c-36,22.3-48.7,70.7-28.3,108c8.3,15,21.7,26.7,37.7,32.7C219.7,398.3,226.3,412.7,221.7,425.7z M497.3,455l-78,48.3 c-19.7,12.3-41.7,18.3-64,18.3c-10,0-20.3-1.3-30.3-4c-32-8.3-59-29.3-75-58.7c-33.3-60-12.7-138.3,45.7-174.7l8.7-6.3 c11.3-8,27-5.3,35,5.7c8,11.3,5.3,27-5.7,35l-10.3,7.3c-37.3,23.3-50,71.7-29.7,108.7c9.7,17.3,25.3,29.7,44,34.7s38.3,2,55.3-8.7 l78-48.3c36-22.3,48.7-70.7,28.3-108c-8.3-15-21.7-26.7-37.7-32.7c-13-4.7-19.7-19-14.7-32c4.7-13,19.3-19.7,32-14.7 c27,10,49.7,29.7,64,55.3C576,340.3,555.7,418.7,497.3,455z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetLinkIcon);
export default __webpack_public_path__ + "static/media/get_link_icon.1e9fba2883cea771596138446a4b1a3d.svg";
export { ForwardRef as ReactComponent };